import React from "react";
import { Row, Container, Card, Col } from "react-bootstrap";
import { Link, useNavigate } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import Store from "../store/Store";
import '../css/dashboard.css'

export default () => {
  let { tasks, tables, user } = Store.getState();
  const navigate = useNavigate();

  const redirectToTable = (e, url) => {
    e.preventDefault();
    e.stopPropagation();
    navigate(url);
  };

  // csak aktív feladatok
  const activeTasks = tasks.filter(task => task.completed_at === null);
  const visibleTasks = activeTasks.slice(0, 5);
  const activeTaskCount = activeTasks.length;
  const allTasksCount = tasks.length;
  const visibleTables = tables.slice(0, 5);

  const completedTasksCount = allTasksCount - activeTaskCount;
  const completionPercentage = Math.round((completedTasksCount / allTasksCount) * 100);

  console.log(activeTasks);

  return (
    <div>
      <div className="page-head my-2 d-flex">
        <h3 className="title">
          <strong>Főoldal</strong>
        </h3>
      </div>
      {user?.permissions?.includes('pwaCreateTask') && (
      <Container className="btn-container mb-3">
        <Link to="/new-task" className="btn button">
          <FontAwesomeIcon icon="fa-solid fa-seedling" className="mx-1" />
          Új feladat létrehozása
        </Link>
      </Container>
      )}

      <Col className="active-tasks-block mb-3">
        <Card className="dashboard-table" border="light">
          <Card.Header className="d-flex justify-content-between align-items-center">
            <div className="d-flex align-items-center">
              <FontAwesomeIcon className="icon peach" icon="seedling" />
              <div className="ms-2">
                <strong>Aktív feladatok</strong>
              </div>
            </div>
            <div className="d-flex align-items-center active-task-count">
              <span className="btn button btn-flt-r peach-bg">
                {activeTaskCount}
              </span>
            </div>
          </Card.Header>

          <Card.Body>
            {visibleTasks.map((task) => (
              <div className="row" key={task.id}>
                <div className="d-flex justify-content-between w-100">
                  <div className="d-flex align-items-center">
                    <FontAwesomeIcon className="icon" icon="seedling" />
                    <div className="ms-2 taskname">
                      <strong>{task.name}</strong>
                    </div>
                  </div>
                  <div className="d-flex align-items-center go-to-task">
                    <span className="btn button btn-flt-r px-3" onClick={(e) => redirectToTable(e, `/edit-task/${task.guid}`)}>
                      <FontAwesomeIcon icon="fa-solid fa-arrow-right" />
                    </span>
                  </div>
                </div>
              </div>
            ))}
          </Card.Body>

          {activeTaskCount > 5 && (
            <Card.Footer>
                <Link to="/task?is-completed=false" className="btn button w-100">
                  Összes aktív feladat
                </Link>
            </Card.Footer>
          )}
        </Card>
      </Col>

      <Col className="progress-block mb-3">
        <Card className="dashboard-table" border="light">
          <Card.Header className="d-flex justify-content-between align-items-center">
            <div className="d-flex align-items-center">
              <FontAwesomeIcon className="icon peach" icon="seedling" />
              <div className="ms-2">
                <strong>Összes feladat</strong>
              </div>
            </div>
            <div className="d-flex align-items-center active-task-count">
              <span className="btn button btn-flt-r peach-bg">
                {allTasksCount}
              </span>
            </div>
          </Card.Header>

          <Card.Body>
              <div className="row" style={{ height: "auto" }}>
                <div className="d-flex justify-content-between w-100">
                  <div className="d-flex align-items-center">
                    <div className="m-2 taskname">
                      <strong>Készültségi szint: {completionPercentage}%</strong>
                    </div>
                  </div>
                </div>
                <div className="m-2 w-100">
                  <div className="progress">
                      <div 
                        className="progress-bar peach-bg" 
                        role="progressbar" 
                        style={{ width: `${completionPercentage}%` }} 
                        aria-valuenow={completionPercentage} 
                        aria-valuemin="0" 
                        aria-valuemax="100">
                      </div>
                  </div>
                </div>
              </div>
          </Card.Body>

          <Card.Footer>
              <Link to="/task" className="btn button w-100">
                Összes feladat
              </Link>
          </Card.Footer>
        </Card>
      </Col>


      <Col className="tables-block mb-3">
        <Card className="dashboard-table" border="light">
          <Card.Header className="d-flex justify-content-between align-items-center">
            <div className="d-flex align-items-center">
              <FontAwesomeIcon className="icon peach" icon="location-dot" />
              <div className="ms-2">
                <strong>Táblacsoportok</strong>
              </div>
            </div>
          </Card.Header>

          <Card.Body>
            {visibleTables.map((table) => (
              <div className="row" key={table.table_id}>
                <div className="d-flex justify-content-between w-100">
                  <div className="d-flex align-items-center">
                    <FontAwesomeIcon className="icon" icon="location-dot" />
                    <div className="ms-2 taskname">
                      <strong>{table.name}</strong>
                      {<span className="table-name-counter ml-1">{tasks.filter(task => task.table_id.includes(table.table_id)).length}</span>}
                    </div>
                  </div>
                  <div className="d-flex align-items-center go-to-task">
                    <span className="btn button btn-flt-r px-3" onClick={(e) => redirectToTable(e, `/task/${table.table_id}`)}>
                      <FontAwesomeIcon icon="fa-solid fa-arrow-right" />
                    </span>
                  </div>
                </div>
              </div>
            ))}
          </Card.Body>

          {tables.length > 5 && (
            <Card.Footer>
                <Link to="/tables" className="btn button w-100">
                  Összes táblacsoport
                </Link>
            </Card.Footer>
          )}
        </Card>
      </Col>
    </div>
  );
};
